"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationFlagEnum = void 0;
var ConversationFlagEnum;
(function (ConversationFlagEnum) {
    ConversationFlagEnum["CustomerResponded"] = "CustomerResponded";
    ConversationFlagEnum["New"] = "New";
    ConversationFlagEnum["NoUpdatedIn7Days"] = "NoUpdatedIn7Days";
})(ConversationFlagEnum = exports.ConversationFlagEnum || (exports.ConversationFlagEnum = {}));
